
export default {
    MessageNames : {
        ERRMSG : 'ERRMSG',
        HAND : 'HAND',
        LOCK : 'LOCK',
        CHAT : 'CHAT',
        CALL : 'CALL',
        IMAGE : 'IMAGE',
        SYSTEM_CHECK: 'SYSTEM_CHECK',
        BROADCAST: 'BROADCAST'
    },
    EventTypes : {
        BROADCAST_CHAT: "BROADCAST_CHAT",
        BROADCAST_CALL: "BROADCAST_CALL",
        VIDEO_MONITORING_CALL: "VIDEO_MONITORING_CALL",
        VIDEO_MONITORING_STATUS_UPDATE: "VIDEO_MONITORING_STATUS_UPDATE",
        FORCE_EXIT_CALL: "FORCE_EXIT_CALL",
        ANSWER_VIDEO_MONITORING_CALL: "ANSWER_VIDEO_MONITORING_CALL",
        LEFT_VIDEO_MONITORING_CALL: "LEFT_VIDEO_MONITORING_CALL",
        TESTER_SUSPEND_VIDEO_MONITORING: "TESTER_SUSPEND_VIDEO_MONITORING",
        TESTER_RESTARTING_VIDEO_MONITORING: "TESTER_RESTARTING_VIDEO_MONITORING",
        BROADCAST_END_CALL: "BROADCAST_END_CALL",
        BROADCAST_TOGGLE_MUTE: "BROADCAST_TOGGLE_MUTE",
        TESTER_ALREADY_IN_VIDEO_MONITORING_CALL: "TESTER_ALREADY_IN_VIDEO_MONITORING_CALL",
        ERRMSG: 'RTP:Error',
        RAISE_HAND: 'RAISE_HAND',
        LOWER_HAND: 'LOWER_HAND',
        UNLOCK_ALL_TESTERS: 'UNLOCK_ALL_TESTERS',
        UNLOCK_TESTER_ON_PROCTOR_SIDE: 'UNLOCK_TESTER_ON_PROCTOR_SIDE',
        UNLOCK_TESTER: 'UNLOCK_TESTER',
        CHANGE_IMAGE_FREQUENCY: 'CHANGE_IMAGE_FREQUENCY',
        INITIATE_CHAT: 'INITIATE_CHAT',
        RECEIVED_CHAT: 'RECEIVED_CHAT',
        SEND_CHAT: 'SEND_CHAT',
        END_CHAT: 'END_CHAT',
        INITIATE_CALL: 'INITIATE_CALL',
        TESTER_ALREADY_IN_CALL: 'TESTER_ALREADY_IN_CALL',
        TESTER_NOT_IN_CALL: 'TESTER_NOT_IN_CALL',
        TESTER_LEFT: 'TESTER_LEFT',
        ANSWER_CALL: 'ANSWER_CALL',
        END_CALL: 'END_CALL',
        PROCTOR_FAILED_TO_CONNECT_CALL: 'PROCTOR_FAILED_TO_CONNECT_CALL',
        TESTER_LEFT_CALL: 'TESTER_LEFT_CALL',
        TESTER_FAILED_TO_CONNECT_CALL: 'TESTER_FAILED_TO_CONNECT_CALL',
        TESTER_FAILED_TO_CONNECT_VIDEO_MONITORING_CALL: 'TESTER_FAILED_TO_CONNECT_VIDEO_MONITORING_CALL',
        TESTER_IMAGE: 'TESTER_IMAGE',
        UNANSWERED_CALL: 'UNANSWERED_CALL',
        SYSTEM_CHECK_SUCCESS: 'SYSTEM_CHECK_SUCCESS',
        SYSTEM_CHECK_FAIL: 'SYSTEM_CHECK_FAIL',
        HEARTBEAT: 'HEARTBEAT'
    },
    Role:{
        TESTER : 'TESTER',
        PROCTOR : 'PROCTOR'
    },
    Keys : {
        CONTROL : 'control',
        SHIFT : 'shift',
        ALT : 'alt'
    },
    TesterImageStatus : {
        NOT_JOINED : 'NOT_JOINED',
        ACTIVE : 'ACTIVE',
        EXITED : 'EXITED',
        LEFT : 'LEFT',
        CAMERA_NOT_WORKING : 'CAMERA_NOT_WORKING'
    },
    ForceExit : {
        DEFAULT_LIMIT_MILLISECONDS : 60000
    },
    TesterVideoConnectionToSession : {
        CONNECTED : 'CONNECTED',
        DISCONNECTED : 'DISCONNECTED',
        CONNECTING : 'CONNECTING',
        UNSTABLE : 'UNSTABLE',
        PENDING : 'PENDING',
        SUSPENDED: 'SUSPENDED',
        RESTARTING: 'RESTARTING'
    },
    MonitoringType : {
        BY_IMAGE: 'byImage',
        BY_VIDEO: 'byVideo'
    },
    VideoQualityTypes : {
        LOW: "LOW",
        STANDARD: "STANDARD",
        HIGH: "HIGH"
    },
    Prefixes : {
        RTP_CHANNEL_PREFIX: "rtp:",
        RTP_PROCTORS_COORDINATION_CHANNEL_PREFIX: "coord_",
        VIDEO_PREFIX: "rtp-tester-video-",
        IMAGE_PREFIX: "rtp-tester-image-"
    },
    VideoQualityOptions : {
        LOW: {
            label: "Low Quality",
            width: 320,
            height: 180,
            frameRate: 15,
            maxBandwidth: 150,
            useCase: "Minimal video, low-bandwidth"
        },
        STANDARD: {
            label: "Standard (SD)",
            width: 640,
            height: 360,
            frameRate: 15,
            maxBandwidth: 400,
            useCase: "Standard video calls with balanced quality and performance"
        },
        HIGH: {
            label: "High Quality (HD)",
            width: 960,
            height: 540,
            frameRate: 15,
            maxBandwidth: 400,
            useCase: "High clarity for presentations or primary speakers"
        }
    },
    ImageCapture: {
        MAX_IMAGE_SIZE: 65000
    },
    VideoCapture: {
        HEARTBEAT_CHECK_INTERVAL_MS: 5000,
        CONNECTING_DELAY_MS: 1000,
        MAX_MEETING_AGE_MS: 7200000, // 2 hours
        MAX_LOCK_STATUS_AGE_MN: 120  // 2 hours
    },
    RetrieveHistory: {
        DEFAULT_LIMIT_MINUTE: 30
    },
    EndGroupCallReason: {
        NETWORK_ISSUE: "NETWORK_ISSUE"
    },
    DIALOG_OFFSET: {
        DIALOG_LEFT_OFFSET: 8,
        DIALOG_TOP_OFFSET: 30
    }

};


const KendoChatTemplate = kendo.template(
    '<div class="#=styles.message#">' +
    '<time class="#=styles.messageTime#">#= kendo.toString(kendo.parseDate(timestamp), "hh:mm tt") #</time>' +
    '<div class="rtpChatMessage" id="rtpchat-#=timestamp#"><div class="#=styles.bubble#">#:text#</div><div><i class="k-icon k-font-icon rtp-icon-darkblue"></i></div></div>' +
    '</div>');

const KendoRecieveChatTemplate = kendo.template(
    '<div class="#=styles.message#">' +
    '<time class="#=styles.messageTime#">#= kendo.toString(kendo.parseDate(timestamp), "hh:mm tt") #</time>' +
    '<div class="#=styles.bubble#">#:text#</div>' +
    '</div>');

const KendoNotificationTemplate = kendo.template(
    '<div class="notification">' +
    '<time class="#=styles.messageTime#" style="position: inherit; margin-right: 8px;">#= kendo.toString(kendo.parseDate(timestamp), "hh:mm tt") #</time>' +
    '<span>#:text#</span>' +
    '</div>');

const KendoBroadcastTemplate = kendo.template(
    '<div class="#=styles.message# rtp-broadcast-group">' +
    '<time class="#=styles.messageTime#">#= kendo.toString(kendo.parseDate(timestamp), "hh:mm tt") #</time>' +
    '<div class="rtp-broadcast-chat"><b>#=title#</b>: #:text#</div>' +
    '</div>'
);

const KendoHelpTextTemplate = kendo.template('<div>#=text#</div></div>');

kendo.chat.registerTemplate("text", KendoRecieveChatTemplate);
kendo.chat.registerTemplate("message", KendoChatTemplate);
kendo.chat.registerTemplate("notification", KendoNotificationTemplate);
kendo.chat.registerTemplate("broadcast", KendoBroadcastTemplate);
kendo.chat.registerTemplate("helpText", KendoHelpTextTemplate);
